<template>
    <l-table
        :columns="data.columns"
        :dataSource="dataSource"
        height="notset"
    >
    </l-table>
</template>
<script>
export default {
    name: 'viewer-table',
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        paramFiled:[String,Number]
    },
    data() {
        return {
            dataSource:[]
        }
    },
    mounted(){
        this.viewTableData()
    },
    watch:{
        paramFiled(){
            this.viewTableData()
        }
    },
    methods: {
        async viewTableData(){
            if(this.paramFiled){
                const apiDbsource = window.$api.data.dbsource
                const data = await this.$awaitWraper(apiDbsource.getDataListByParamter(this.data.dataCode,this.paramFiled))
                this.dataSource =  data || []
            }
            else{
                this.dataSource = []
            }
            
        }
    }
}
</script>